import { getChannelAPIPath } from '@treasury/core/http';

InternalTransfersService.$inject = ['$resource'];

export default function InternalTransfersService($resource) {
    const resourceUrl = `${getChannelAPIPath()}internalTransfers/`;
    let selectedTemplates = [];

    return {
        save,
        getTransaction,
        getTransferList,
        getLoanPaymentsList,
        getRecurringTransfersList,
        approveTransfer,
        rejectTransfer,
        cancelTransfer,
        updateTransfer,
        batchApprove,
        batchReject,
        getTransferTemplateList,
        approveOrRejectTransferTemplate,
        getTransferTemplate,
        saveTransferTemplate,
        updateTransferTemplate,
        setSelectedTemplates,
        getSelectedTemplates,
        getTransferTemplateDetails,
        deleteTransferTemplate,
        validateTemplateName,
    };

    function setSelectedTemplates(templates) {
        selectedTemplates = [];
        if (Array.isArray(templates)) {
            selectedTemplates = templates;
        } else {
            selectedTemplates.push(templates);
        }
    }

    function getSelectedTemplates() {
        return selectedTemplates;
    }

    /**
     *
     * @returns { Promise<import('@treasury/api/channel').InternalTransferTransactionModelDto>}
     */
    function save(model) {
        return $resource(`${resourceUrl}?type=add`).save(model).$promise;
    }

    function saveTransferTemplate(model) {
        return $resource(`${resourceUrl}saveTransferTemplate/?type=:type`, {
            type: model.type,
        }).save(model).$promise;
    }

    function updateTransferTemplate(model) {
        return $resource(
            `${resourceUrl}updateTransferTemplate`,
            {},
            { update: { method: 'PUT' } }
        ).update(model).$promise;
    }
    function updateTransfer(transferMessage) {
        return $resource(
            `${resourceUrl}:id`,
            { id: transferMessage.id },
            { update: { method: 'PUT' } }
        ).update(transferMessage).$promise;
    }
    function getTransaction(id) {
        return $resource(`${resourceUrl}?id=:id`, { id }).get().$promise;
    }

    function getTransferList(filter) {
        return $resource(`${resourceUrl}FilterTransfers`, null, {
            get: { method: 'POST', isArray: true },
        }).get(filter).$promise;
    }

    function getLoanPaymentsList(filter) {
        return $resource(`${resourceUrl}getLoanPayments`, null, {
            get: { method: 'POST', isArray: true },
        }).get(filter).$promise;
    }

    function getRecurringTransfersList(filter) {
        return $resource(`${resourceUrl}getRecurringTransfers`, null, {
            get: { method: 'POST', isArray: true },
        }).get(filter).$promise;
    }

    function approveTransfer(transfer) {
        return $resource(`${resourceUrl}:id/approve`, { id: transfer.id }).save(transfer).$promise;
    }

    function rejectTransfer(transfer) {
        return $resource(`${resourceUrl}:id/reject`, { id: transfer.id }).save(transfer).$promise;
    }

    function cancelTransfer(cancelTransferModel) {
        return $resource(`${resourceUrl}cancel`).save(cancelTransferModel).$promise;
    }

    function batchApprove(batchData) {
        return $resource(`${resourceUrl}batchApprove`).save(batchData).$promise;
    }

    function batchReject(batchData) {
        return $resource(`${resourceUrl}batchReject`).save(batchData).$promise;
    }
    function getTransferTemplateList(filter) {
        return $resource(`${resourceUrl}getTransferTemplates`, null, {
            get: { method: 'POST', isArray: true },
        }).get(filter).$promise;
    }
    function approveOrRejectTransferTemplate(type, id) {
        return $resource(`${resourceUrl}:id/approverejecttemplate`, { id, type }).save().$promise;
    }

    function deleteTransferTemplate(id) {
        return $resource(`${resourceUrl}:id/deletetemplate`, { id }).save().$promise;
    }

    function getTransferTemplate(id) {
        return $resource(`${resourceUrl}getTemplateById/:id`, { id }).get().$promise;
    }

    function getTransferTemplateDetails(id, type) {
        return $resource(`${resourceUrl}getTransferTemplateDetails/:id`, {
            id,
            type,
        }).get().$promise;
    }

    function validateTemplateName(name) {
        return $resource(`${resourceUrl}validateTemplateName/`, { templateName: name }).get()
            .$promise;
    }
}
